import { Handler } from '@hlibs/index';

const OnSocketMessage = new Handler();

export default {
    OnSocketMessage
};